module.exports = __webpack_public_path__ + "static/accounts_1-e482393b8607c96ad00ad5b975905820.png";